// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"923b533b","253":"dedcf3ae","327":"f303d7fb","346":"5784944f","453":"a0ef5a89","553":"39961ebe","566":"3625e27c","590":"e837116f","598":"bd1cb42d","635":"c72867e0","808":"b8a984de","854":"3c8d6c59","924":"b77faf92","974":"2ab88ff1","979":"cac37a80"}[chunkId] + ".chunk.js";
};